export default "__VITE_ASSET__CYS3E1N3__"